import PurpleTab from "root/s360components/PurpleTab";
import AttendanceSummaryTable from "root/s360components/Tables/AttendanceSummaryTable";
import React from "react";

const DashboardAttendanceSummary = ({school_id}) =>
{

    return (<div className='column-wrapper'>
        <PurpleTab title='% ATTENDANCE SUMMARY'>
            <div className='news-table'>
                <AttendanceSummaryTable school_id={school_id}></AttendanceSummaryTable>
            </div>
        </PurpleTab>
    </div>);
}

export default DashboardAttendanceSummary;